import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Card, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import { updateClinicUserById } from "../../../redux/reducers/clinicSlice";
import { getBorderColor } from "../../../util/function";
import PaymentModeDropdown from "../../CommonComponents/PaymentModeDropdown";

const CollectDeposit = ({
  modVsble = false,
  onCloseMod = () => {},
  payment = {},
  tab = "treatment",
}) => {
  const dispatch = useDispatch();
  const [payValues, setPayValues] = useState({ paymentType: "Collect" });
  const [payErrs, setPayErrs] = useState({});

  const handleValueChange = (value, name) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    const valObj = { ...payValues, [name]: value };
    if (name === "paymentType") {
      valObj.paymentMode = null;
    }
    setPayValues(valObj);
    const errObj = {
      ...payErrs,
      [name]: reqValue?.length > 0 ? "" : "This field is required",
    };
    if (name === "advanceAmount") {
      if (Number(value) <= 0) {
        errObj.advanceAmount = "Amount should be greater than 0";
      } else {
        errObj.advanceAmount = "";
      }
    }
    setPayErrs(errObj);
  };

  const onCollect = () => {
    if (
      payValues?.advanceAmount?.length === 0 ||
      !payValues?.advanceAmount ||
      !payValues?.paymentMode ||
      Number(payValues?.advanceAmount) <= 0
    ) {
      const errs = {};
      if (!payValues?.paymentMode) errs.paymentMode = "This field is required";
      if (payValues?.advanceAmount?.length === 0 || !payValues?.advanceAmount) {
        errs.advanceAmount = "This field is required";
      } else if (payValues?.advanceAmount <= 0) {
        errs.advanceAmount = "Amount should be greater than 0";
      } else {
        errs.advanceAmount = "";
      }
      setPayErrs(errs);
      if (Object.keys(errs)?.length > 0) return;
    }
    const form = new FormData();
    form.append("userName", payment?.userName);
    form.append("userMobile", payment?.mobile);
    form.append("paymentType", payValues?.paymentType);
    form.append("paymentMode", payValues?.paymentMode?.value);
    form.append(
      "advanceAmount",
      Number(
        `${payValues?.paymentType === "Collect" ? "+" : "-"}${
          payValues?.advanceAmount
        }`,
      ),
    );
    if (payment?.petId) form.append("petId", payment?.petId);
    if (payment?.petName) form.append("petName", payment?.petName);
    if (
      tab === "treatment" &&
      (payment?.treatmentInvoiceNumber ?? "")?.length > 0
    ) {
      form.append("invoiceNo", payment?.treatmentInvoiceNumber);
    }
    if (tab === "pharmacy" && (payment?.invoiceNumbers ?? "")?.length > 0) {
      form.append("invoiceNo", payment?.invoiceNumbers);
    }
    if (
      tab === "petShop" &&
      (payment?.petShopInvoiceNumber ?? "")?.length > 0
    ) {
      form.append("invoiceNo", payment?.petShopInvoiceNumber);
    }
    dispatch(
      updateClinicUserById({
        userId: payment?.userId,
        form,
        successMsg: "Payment updated successfully!",
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseMod("apiSuccess");
      }
    });
  };

  return (
    <CustomModal
      open={modVsble}
      onClose={() => onCloseMod("close")}
      header="Collect Deposit"
      rightModal
      modalWidth={30}
    >
      <div className="flex-center">
        <Card
          sx={{
            borderRadius: 1,
            padding: 2,
            borderTopColor: `${getBorderColor("paid")}`,
          }}
          className="pay-card"
        >
          <div className="maint">
            <div>
              <div className="flex-row parentcontainer">
                <div className="flex-row  iconcontainer">
                  <AccountCircleOutlinedIcon sx={{ width: 25, height: 25 }} />
                  <Typography className="  font-bold fs14 capitalize flex-center h35">
                    {payment?.userName}
                  </Typography>
                </div>
              </div>

              <div className="datecontainer" />
            </div>
          </div>
        </Card>
      </div>
      <Grid container spacing={2} className="ph20">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="flex-row-ali-cen">
            <Typography className="font-medium fs14 green-color mt15">
              Available Balance:{" "}
              {Number(payment?.advanceAmount)
                ? `Rs ${Number(payment?.advanceAmount).toFixed(2)}`
                : "Nil"}
            </Typography>
            <div className="ml10"></div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="flex-row-ali-cen">
            <Typography className="font-medium fs14 black mb5">
              Credit Balance:
            </Typography>
            <div className="ml10">
              <CustomCheckbox
                radio
                value={payValues?.paymentType}
                onChange={(e) =>
                  handleValueChange(e?.target?.value, "paymentType")
                }
                radios={[{ label: "Collect", value: "Collect" }]}
                defaultValue={payValues?.paymentType}
              />
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="mb20">
            <CustomTextField
              label="Amount"
              name="advanceAmount"
              fullWidth
              handleChange={(e) =>
                handleValueChange(e?.target?.value, "advanceAmount")
              }
              value={payValues?.advanceAmount}
              error={!!payErrs.advanceAmount}
              helperText={payErrs.advanceAmount}
              type="number"
            />
          </div>
        </Grid>

        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <div className="mb20">
            <PaymentModeDropdown
              list={[]}
              value={payValues?.paymentMode}
              onChange={(e) => handleValueChange(e, "paymentMode")}
              hideAdvancedAdjustment
              error={!!payErrs.paymentMode}
              helperText={payErrs.paymentMode}
            />
          </div>
        </Grid>
        <div className="flex1-end mt20">
          <div>
            <CustomButton text="Collect Deposit" onClick={onCollect} smallBtn />
          </div>
        </div>
      </Grid>
    </CustomModal>
  );
};

export default CollectDeposit;
